export default "__VITE_ASSET__GUd5utbS__"